import { render } from "./SvgComponent.vue?vue&type=template&id=c3d1b928"
import script from "./SvgComponent.vue?vue&type=script&lang=js"
export * from "./SvgComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__